import { AcademyListType, AcademyEditType } from '@/models/academyListModel'
import { PaginationStatus } from '@/models/paginationModel'
import { ApiResponseAcademyList, ApiResponseAcademyEditData } from '@/models/apiResponses/academies'

export class AcademyManagementUtils {
  /**
   * 塾一覧情報に変換する
   * @param apiResponse 塾一覧検索APIレスポンス
   * @returns 塾一覧情報
   */
  public static formatAcademyDatas(apiResponse: ApiResponseAcademyList): AcademyListType[] {
    if (!apiResponse) return []

    return apiResponse.responses
  }

  /**
   * ページネーションの状態を取得
   * @param apiResponse 塾一覧検索APIレスポンス
   * @returns ページネーション情報
   */
  public static getPagenationStatus(apiResponse: ApiResponseAcademyList): PaginationStatus | null {
    if (!apiResponse) return null

    return apiResponse.pagination
  }

  /**
   * 塾編集情報を生成する
   * @param apiResponse 塾情報取得APIのレスポンス
   * @returns 塾編集情報
   */
  public static buildAcademyEditData(apiResponse?: ApiResponseAcademyEditData): AcademyEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        academyName: '',
        academyCode: '',
      }
    }

    return {
      id: apiResponse.id,
      academyName: apiResponse.academyName,
      academyCode: apiResponse.academyCode,
    }
  }
}
